import { CatSkeleton } from '@blocks-react/components/Skeleton';

const ContactUsDealerInformationSectionSkeleton = () => {
  return (
    <div className="d-flex flex-column" style={{ gap: '0.25rem' }}>
      <div className="cat-u-padding-bottom-sm">
        <CatSkeleton />
      </div>
      <div
        className="cat-u-margin-top-sm d-flex flex-column"
        style={{ gap: '0.5rem' }}
      >
        <CatSkeleton size="sm" width="95%" />
        <CatSkeleton size="sm" width="60%" />
        <CatSkeleton size="sm" width="45%" />
        <CatSkeleton size="sm" width="80%" />
      </div>
    </div>
  );
};

export default ContactUsDealerInformationSectionSkeleton;
